import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AssignTeamMemberEditPage } from './assign-team-member-edit.page';

const routes: Routes = [
  {
    path: '',
    component: AssignTeamMemberEditPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AssignTeamMemberEditPageRoutingModule {}
